import { convertUTCtoMSK } from '../../../../../utils'
import { formatSum } from '../../../../../utils/formatSum'
import { PayoutTokenLink } from '../../../../common/PayoutTokenLink'

interface Props {
  ticket: {
    paymentTicketToken: string
    matchingTicketToken: string
    virtualPayoutTicketToken: string
    amount: number
    createdAt: string
  }
}

const VirtualMerchantItem = ({ ticket }: Props) => {
  return (
    <tr>
      <td>
        <div className='d-flex flex-column'>
          <div className='text-dark fw-normal mb-1'>
            <span className='text-muted'>Мэтчинг:</span> {ticket.matchingTicketToken}
          </div>
          <div className='text-dark fw-normal mb-1'>
            <span className='text-muted'>Пополнение:</span> {ticket.paymentTicketToken}
          </div>
          <div className='text-dark fw-normal'>
            <span className='text-muted'>Выплата:</span>{' '}
            <PayoutTokenLink token={ticket.virtualPayoutTicketToken} />
          </div>
        </div>
      </td>
      <td>
        <div className='text-dark fw-bold'>{formatSum(ticket.amount)}</div>
      </td>
      <td>
        <div className='text-dark'>{convertUTCtoMSK(ticket.createdAt)}</div>
      </td>
    </tr>
  )
}

export default VirtualMerchantItem

